import React from 'react';

const LoadingState = ({ message = 'Loading products...' }) => {
    return (
        <div className="jk-catalog__loading">
            <div className="jk-catalog__loading-spinner">
                <div className="jk-catalog__loading-spinner-circle"></div>
            </div>
            <p className="jk-catalog__loading-text">{message}</p>
        </div>
    );
};

export default LoadingState;
